
import Info from "../../../templates/info";
import { OFFERINGS } from "./constants";

export default function Offerings() {
  return <Info INFO={OFFERINGS} />
}